{
	"showMore": "Mostrar mais ({{remainingElements}})",
	"showLess": "Mostrar menos"
}
